module.exports = __webpack_public_path__ + "img/complete_setup.f1c48846.svg";